import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { reactive, ref, watch, Ref, toRefs } from 'vue';
import { useRouter, useRoute, NavigationFailureType, isNavigationFailure } from 'vue-router';
import type { RouteRecordRaw } from "vue-router";
import { useStore } from 'vuex';
import { pathType } from '@/util/interface/route/route';




export default /*@__PURE__*/_defineComponent({
  __name: 'side',
  props: {
    menu: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;
// const emit = defineEmits<{

// }>()

const route = useRoute()
const router = useRouter();
const store = useStore();

const { menu } = toRefs(props)

const state = reactive({
  activeName: ''
})

// watch(() => route.name, val => {


//     let activeName = isInMenu(val as string, store.state.menuList);
//     if(activeName) {
//         state.activeName = activeName
//     }else {
//         let pSort = (route.meta?.sort + '')[0];
//         let data = store.state.menuList.filter((t: any) => t.meta?.sort == pSort)[0];
//         state.activeName = data.name as string
//         console.log(route)
//     }
//     console.log(state.activeName)
// })

const selectMenu = async (name: string) => {
  let data = store.state.routeOriginList.filter((t: any) => t.code == name)[0];
  switch(data.pathType) {
    case pathType.mine:
      const failRouter = await router.push({ name });
      // 检测路由跳转，失败则去到notFound
      if (isNavigationFailure(failRouter, NavigationFailureType.aborted)) {
        router.push({ path: '/notFound' })
      }

      break;
    case pathType.iframe:
      let arr = data.path.split('#');
      let path = arr[1].match(/\?/) || '';
      if (path) {
        path = '&token=' + store.state.accessToken
      } else {
        path = '?token=' + store.state.accessToken
      }
      console.log(path)
      router.push({
        name: 'webIframe',
        query: {
          url: encodeURIComponent(`${arr[0]}?_times=${new Date().getTime()}/#${arr[1]}${path}`)
        }
      })
      break;
    case pathType.tag:
      let tagarr = data.path.split('#');
      let tagpath = tagarr[1].match(/\?/) || '';
      if (tagpath) {
        tagpath = '&token=' + store.state.accessToken
      } else {
        tagpath = '?token=' + store.state.accessToken
      }
      console.log(tagpath)
      window.open(`${tagarr[0]}?_times=${new Date().getTime()}/#${tagarr[1]}${tagpath}`)
      // 
      break;

  }
}

const {
  activeName
} = toRefs(state)

return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    "default-active": 1,
    onSelect: selectMenu,
    class: "side h-100 base-bg over-auto",
    "text-color": "#fff"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menu), (item, idx) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: item.meta.id
        }, [
          (item.children?.length)
            ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                key: 0,
                index: (item.path as string)
              }, {
                title: _withCtx(() => [
                  (item.meta?.icon)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta?.icon), { key: 0 }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(item.meta?.title), 1)
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (it, index) => {
                    return (_openBlock(), _createBlock(_component_el_menu_item, {
                      index: it.name as string,
                      key: (it.meta?.id as string)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(it.meta?.title), 1)
                      ]),
                      _: 2
                    }, 1032, ["index"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["index"]))
            : (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: item.name as string
              }, {
                default: _withCtx(() => [
                  (item.meta?.icon)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.meta?.icon), { key: 0 }))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(item.meta?.title), 1)
                ]),
                _: 2
              }, 1032, ["index"]))
        ], 64))
      }), 128))
    ]),
    _: 1
  }))
}
}

})